import {request, setAuthInHeader} from "@/api/request";
import util from "@/mixins/util";

const state = {
    SoInfo: [],
};

const getters = {
    getSoInfo: (state) => state.SoInfo,
};

const mutations = {
    updateSoInfo(state, obj) {
        state.SoInfo = obj.value;
    },
    resetSoInfo(state) {
        state.SoInfo = {};
    },
};

const actions = {
    setSoInfo({commit, rootState}) {
        if(state.SoInfo.length > 0) {
            return;
        }
        let params = {
            sdDepth: 0,
        };
        request.javaGet("v1/so", params).then(
            (res) => {
                if (!res) {
                    return false;
                }
                let result = res.data;
                if (result.code > 0 && !util.isEmpty(result.result.list)) {
                    commit("updateSoInfo", {value: result.result.list});
                } else {
                    commit("updateSoInfo", {value: {}});
                }
            },
            () => {
                console.log("error");
            }
        );
    },
    changeSoInfo({commit, rootState}, {data}) {
        commit("updateAreaDong", {value: data});
    },
    initSoInfo({commit, rootState}, {data}) {
        commit("resetSoInfo");
    },
};

export default {namespaced: true, state, getters, mutations, actions};
